import "./CaseStudyBoutiqueHotelThailandRevenueGrowth.module.css";
import Header from "@/reusable_sections/Header";
import RevenueGrowthHero from "./sections/RevenueGrowthHero";
import Performance from "./sections/Performance";
import RevenueTimeline from "./sections/RevenueTimeline";
import AchievementMetrics from "./sections/AchievementMetrics";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudyBoutiqueHotelThailandRevenueGrowthPage() {
  return <div>
      <Header />
      <RevenueGrowthHero />
      <Performance />
      <RevenueTimeline />
      <AchievementMetrics />
      <Faq />
      <Footer />
    </div>;
}